/**
 * OBJECTIVE : THIS FILE CONTAINS THE ALL CONSTANTS THOSE ARE 
 * RELATED TO REPORT MODULE.
 */

import * as moment from 'moment';
export const constants = {
    URL: {
        REPORT: 'dashboard/report/waybill-summary',
        WAYBILL_DEATIL: 'dashboard/report/waybill-summary/details',
        WAYBILL_TRIP_DEATIL: 'dashboard/report/waybill-summary/tripDetails',
        WAYBILLSIGNOFF_DEATIL: 'dashboard/report/waybill-signoff/waybilldetail',
        WAYBILLSIGNOFF:'dashboard/report/waybill-signoff',
        WAYBILLSIGNOFF_DASHBOARD:"reports/afcs/waybill-signoff",
        WAYBILLSIGNOFFAGGREGATE: 'dashboard/report/waybill-signoff/aggregate',
        FIELDAUDITCARDOVERVIEW: 'dashboard/audit-card-summary',
        FIELDAUDITTOTALCARDOVERVIEW: 'dashboard/audit-card-summary-overview',
        FIELDAUDITCARDSCANOVERVIEW: 'dashboard/card-scan-summary',
        FIELDAUDITCARDSCANSUMMARYOVERVIEW: 'dashboard/card-scan-summary-overview',
        FIELDAUDITVIOLENCEREPORT:'bus-details-by-audit-id',
        AUDITBYCREWLIST: 'dashboard/audit-by-crew-overview-list',
        AUDITBYCREWSUMMARY: 'dashboard/audit-by-crew-overview',
        BANKSHEETREPORT: 'dashboard/report/banksheet',
        BANKSHEETAGGREGATE: 'dashboard/report/banksheet/aggregate',
        CASHIERREPORT: 'dashboard/report/cashier',
        NCMCDATA: 'dashboard/report/cashier/ncmc/report',
        TICKETS: 'dashboard/report/waybill-signoff/tickets',
        ALLTICKETS: 'dashboard/report/waybill-signoff/tickets/summary',
        RIDER_REPORT: 'riderReport',
        REVENUE_REPORT: 'kmAndService',
        MASTER_DATA: 'filterType',
        CONDUCTORS_LIST: 'conductorsEarning',
        CONDUCTOR_DETAIL: 'conductorEarning',
        PREPAIDCARD_WAYBILL_REPORT: 'prepaidcardwaybillcollectionreport',
        CARD_TRANSACTION_WAYBILL: 'v3/prepaidcard/waybill/report',
        MASTER: {
            ROUTES: 'getallroutes'
        },
        STOP_WISE_REPORT: 'stopwisereportagency',
        BUS_WISE_REPORT: 'vehiclewisereport',
        REAL_TIME_REPORT: 'vehiclewisereportLive',
        WAYBILL_BATTERY_REPORT: 'batteryconsumptionreport',
        ETIM_BATTERY_REPORT:'batteryconsumptionreportforMachine',
        ETIM_BATTERY_TICKET_REPORT: 'batteryconsumptionreportforTicket',
        DEPOLESS: 'depolessReport',
        TRIPSTATUS: 'tripStatusReport',
        TRIPSTATUSDETAIL: 'getWaybillWiseTripDetail',
        SPOTTICKET: 'spotTickets/waybill',
        SPOTTICKET_DETAIL: 'dashboard/report/waybill-signoff/waybilldetail',
        DENOMINATION_REPORT: 'dashboard/report/denomination-wise',
        DENOMINATION_COLLECTION_REPORT: 'reports/afcs/denomination-collection',
        All_CASHIER: 'dashboard/report/cashier/list',
        CASHIERDAILYDENOM: 'dashboard/dailyops/cashier/report',
        ALL_DENOMCASHIER: 'dashboard/crew/cashier-daily-denom',
        BANKSHEETRTGSREPORT: 'dashboard/report/bank-rtgs',
    },
    WAYBILL_STATUS: {
        COMPLETED: { id: '1', value: 'Completed', backendValue: 'completed' },
        RUNNING: { id: '2', value: 'Running', backendValue: 'running' },
        CANCEL: { id: '3', value: 'Cancel', backendValue: 'canceled' },
        ALLOCATED: { id: '4', value: 'Allocated', backendValue: 'ready' },
    },

    MSG: {
        ERROR: {
            TITLE: 'ERROR',
            DETAIL: 'Something Went Wrong!',
            AUDITOR_NOT_LOGGED_OUT: 'Auditor Not Logged Out',
        },
        NOT_FOUND: 'ERRORS.NO_DATA_FOUND',
        DENOM_NOT_FOUND: 'No Denomination Data Found',
        SELECT_DATE: 'Select Date Filter.'
    },

    XSLS: {
        WAYBILL_DETAIL: {
            SHEETNAME1: 'wayBillDetail' + moment(new Date()).format('DD-MM-YYYY'),
            SHEETNAME2: 'TripsDetail' + moment(new Date()).format('DD-MM-YYYY'),
            SHEETNAME3: 'passengerType' + moment(new Date()).format('DD-MM-YYYY'),
            SHEETNAME4: 'paymentMode' + moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'WayBill',
        },
        WAYBILL_SIGNOFF: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'waybillSignoff'
        },
        TICKET_LIST: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'TicketDetails'
        },
        cardIssue: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'CardIssueReport'
        },
        recharge: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'RechargeReport'
        },
        ncmcrecharge: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'NCMCRechargeReport'
        },
        passIssue: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'PassIssueReport'
        },
        RIDERSHIP: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'RidesListing'
        },
        RIDERSHIP_DETAIL: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'RidesDetails',

        },
        REVENUE_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'RevenueDetails'
        },
        PREPAIDCARD_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'PrepaidCardDetails'
        },
        WAYBILL_SUMMARY: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'WaybillSummary'
        },
        CASHIER_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'CashierCollection'

        },
        DENOMINATION_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'DenominationWise'

        },
        CONDUCTOR_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'ConductorsList'
        },
        CONDUCTOR_DETAIL: {
            SHEETNAME2: moment(new Date()).format('DD-MM-YYYY'),
            SHEETNAME1: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'ConductorDetail'
        },
        TRIPSTATUS_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'TripStatusList'
        },
        TRIPSTATUSDETAIL_REPORT: {
            SHEETNAME: moment(new Date()).format('DD-MM-YYYY'),
            FILENAME: 'TripStatusList'
        }
    },

    TYPE: {
        SERVICE: 'Service_Wise',
        KM: 'Km_Wise'
    },

    INVALIDHITTIME: {
        HITTIME : 10
    },

    FILTER_TYPE: [
        { id: '1', value: 'ETIM No', backendValue: 'machine' },
        { id: '2', value: 'Conductor', backendValue: 'conductor' },
        { id: '3', value: 'Vehicle No', backendValue: 'bus' },
        { id: '4', value: 'Service Type', backendValue: 'bustype' }
    ],

    LOCALSTORAGE_KEYS: {
        WAYBILL_SIGNOFF: 'x-sign-off-f',
        WAYBILL_SUMMARY: 'x-summary-f',
        CASHIER_REPORT: 'x-cashier-f',
        DENOMINATION_REPORT: 'x-denomination-f',
        FIELD_AUDIT_OVERVIEW: 'x-field-audit-overview-f',
        FIELD_AUDIT_CARD_OVERVIEW: 'x-field-audit-card-overview-f',
        FIELD_AUDIT_CITY_CARD_OVERVIEW: 'x-field-audit-city-card-overview-f',
        CARD_BY_BUS: 'x-card-by-bus-f',
        DIRECT_CARD_SCAN:'x-direct-card-scan-f',
        FIELD_AUDIT_BY_CREW: 'x-field-audit-by-crew-f',
        BANK_SHEET: 'x-bank-sheet-f',
        WAYBILL_REAL_DATA: 'x-real-f',
        CONDUCTOR_WISE: 'x-conductor-f',
        REVENUE_REPORT: 'x-revenue-f',
        RIDER_SHIP: 'x-rider-f',
        PREPAIDCARD_LIST: 'x-prepaid-list-f',
        PREPAIDCARDWITHWAYBILL: 'x-prepaid-with-waybill-f',
        TRIP_STATUS: 'x-trip-status-f',
        SPOT_TICKET:'x-spot-ticket-f',
        ASSIGN_ETIM: 'x-assign-etim-f',
        ASSIGN_STATUS: 'x-assign-status-f',
        ROUTE_WISE_REPORT:'x-route-report-f',
        PASS_MANAGEMENT: 'x-pass-management-f',
        FILTER_TYPE: {
            DATE: 'date',
            SEARCH: 'search',
            PAGE_SIZE: 'PageSize',
            DDVAL: 'ddValue',
            AUTOPOPULATE: 'autoPopulateVal'
        },
        BANK_RTGS_SHEET: 'x-bank--rtgs-sheet-f',
        PICKUP_DEACTIVATION: 'x-pickup-deactivation-f',
        ADD_PICKUP_POINTS: 'x-add-pickup-points-f',
    }
}//constants-closes